import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import cx from 'classnames';
import { loadImageFiles } from '../batch/imageFiles';
import MaterialIcon from './MaterialIcon';

export { loadImageFiles };

export default class FilesLoader extends Component {
    uploadMethod = 'drop';

    static defaultProps = {
        onStartLoading: () => Promise.resolve(),
        onComplete: () => Promise.resolve(),
        onError: () => Promise.resolve(),
    };

    static propTypes = {
        onStartLoading: PropTypes.func,
        onComplete: PropTypes.func,
        onError: PropTypes.func,
    };

    openFiles = (files = []) => {
        if (files.length > 0) {
            const method = this.uploadMethod;
            this.uploadMethod = 'drop';
            this.props.onStartLoading();
            loadImageFiles(files)
                .then(result => this.props.onComplete(result, { method }))
                .catch(error => this.props.onError(error, { method }));
        }
    };

    render() {
        return (
            <div className="flex w-full shrink-0 items-center justify-center p-6 pt-8 desk:p-10 min-h-[40vh] desk:min-h-[55vh]">
                <Dropzone accept="image/*" onDrop={this.openFiles}>
                    {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, open }) => (
                        <div
                            {...getRootProps()}
                            className={cx(
                                'flex w-full max-w-xl cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed px-8 py-16 text-center transition-colors',
                                {
                                    'border-primary bg-primary/5': isDragAccept,
                                    'border-danger bg-danger/5': isDragReject,
                                    'border-border-subtle bg-white hover:border-primary/50 hover:bg-surface': !isDragActive,
                                }
                            )}
                        >
                            <MaterialIcon name="cloud_upload" className="mb-4 h-12 w-12 text-primary/70" />
                            <input {...getInputProps()} />
                            <p className="text-headline-md text-on-surface mb-2">Drop images here</p>
                            <p className="text-body-md text-secondary mb-6">or browse from your device</p>
                            <button
                                type="button"
                                className="rounded-lg bg-primary px-6 py-2.5 text-body-md font-semibold text-white transition-colors hover:bg-primary-dark"
                                onClick={e => {
                                    e.stopPropagation();
                                    this.uploadMethod = 'picker';
                                    open(e);
                                }}
                            >
                                Select Files
                            </button>
                            <p className="text-label-md text-secondary mt-6">JPG, PNG, WebP, GIF — any size</p>
                            {isDragReject && (
                                <p className="text-body-md text-danger mt-4">Unsupported file type</p>
                            )}
                        </div>
                    )}
                </Dropzone>
            </div>
        );
    }
}
